import { component } from 'picoapp';
var hoverintent = require('hoverintent');
import { gsap } from 'gsap';

class DesktopNav {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.mainOptions = el.querySelectorAll('.Nav__item--level1.has-submenu');
    this.init();
  }

  init(){
    this.mainOptions.forEach((item) => {
      let submenu = item.querySelector('.Nav__submenu.level-2');
      hoverintent(
        item,
        (e) => this.open(e, item, submenu),
        (e) => this.close(e, item, submenu)
      );
      item.addEventListener('focus', (e) => this.open(e, item, submenu), true);
      item.addEventListener('focusout', (e) => this.close(e, item, submenu), false );
    });
  }
  open(e, item, submenu){ 
    if(e.type == 'focus' && item.classList.contains('is-hover')){
      //Allow navigation with tab key
      return
    } else {
      item.classList.add('is-hover');
      gsap.set(submenu, { display: 'block', immediateRender: false });
      gsap.fromTo(submenu, { y: 10, opacity: 0 }, { y: 0, opacity: 1, duration: 0.4 });
    }
  }
  close(e, item, submenu){
    if(e.type == 'focusout' && item.classList.contains('is-hover') && item.contains(e.relatedTarget)){
      //Allow navigation with tab key
      return;
    } else { 
      item.classList.remove('is-hover');
      gsap.fromTo(
        submenu,
        { y: 0, opacity: 1 },
        {
          y: 20,
          opacity: 0,
          duration: 0.3,
          onComplete: () => {
            gsap.set(submenu, { display: 'none' });
          },
        }
      );
    }
  }
}

export default component((node, ctx) => {
  new DesktopNav(node, ctx);
});
